import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { updatePageTitle } from "../utils/pageTitle";

/**
 * Custom hook to automatically update page titles based on current route
 * This hook should be used in the main App component to ensure title updates
 * happen for all route changes
 */
export const usePageTitle = () => {
    const location = useLocation();

    useEffect(() => {
        updatePageTitle(location.pathname);
    }, [location.pathname]);

    return location.pathname;
};

/**
 * Custom hook for manually setting a page title
 * Use this in individual components when you need to override the automatic title
 * @param {string} title - The camel case title to set
 */
export const useCustomPageTitle = (title) => {
    useEffect(() => {
        if(title) {
            document.title = `${title} | AQI`;
        }
    }, [title]);
};
